import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgZorroAntdModule, NZ_I18N, zh_CN } from 'ng-zorro-antd';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CustomerComponent } from './customer/customer.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductComponent } from './product/product.component';
import { PanelComponent } from './panel/panel.component';
import { ReportComponent } from './report/report.component';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { BaseSearchComponent } from './components/base-search/base-search.component';
import { HttpErrorHandler } from 'src/service/http-error-handler.service';
import { UtilsService } from 'src/utils/utils.service';
registerLocaleData(zh);
@NgModule({
  declarations: [						
    AppComponent,
    CustomerComponent,
    ProductComponent,
    PanelComponent,
    ReportComponent,
    BaseSearchComponent,
   ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    NgZorroAntdModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [{ provide: NZ_I18N, useValue: zh_CN },HttpErrorHandler,UtilsService],
  bootstrap: [AppComponent]
})
export class AppModule { }
